import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { CheckCircle2, ArrowRight } from "lucide-react";

export const ProfileCompletion = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/coach/completion").then(({ data }) => setData(data)).catch(() => {});
  }, []);

  if (!data || data.pct >= 100) return null;
  return (
    <div className="border border-blaze/60 bg-[#140A08] p-5 mb-6" data-testid="profile-completion-card">
      <div className="flex items-center justify-between flex-wrap gap-2">
        <div className="heading text-xl" data-testid="completion-headline">
          YOUR PROFILE IS <span className="text-blaze">{data.pct}%</span> COMPLETE
        </div>
        <div className="text-[10px] tracking-widest text-neutral-500">MORE COMPLETE = BETTER MATCHES</div>
      </div>
      <div className="mt-3 h-2 bg-neutral-900" data-testid="completion-bar">
        <div className="h-full bg-blaze transition-all" style={{ width: `${Math.max(4, data.pct)}%` }} />
      </div>
      {data.missing.length > 0 && (
        <>
          <div className="mt-4 text-xs text-neutral-400">
            Complete {data.missing.length === 1 ? "this item" : `these ${data.missing.length} items`} to strengthen your profile:
          </div>
          <div className="mt-2 flex flex-wrap gap-2" data-testid="completion-missing-items">
            {data.missing.map((m) => (
              <Link key={m.key} to={m.href} data-testid={`complete-${m.key}-btn`}
                className="inline-flex items-center gap-1.5 border border-neutral-700 px-3 py-2 text-xs text-neutral-200 hover:border-blaze hover:text-blaze transition-colors">
                <CheckCircle2 size={12} /> {m.label} <ArrowRight size={11} />
              </Link>
            ))}
          </div>
        </>
      )}
    </div>
  );
};
